<template>
    <div>
        <b-modal
            size="md"
            v-model="modalShow"
            :title="`${$locale.consultation_host}科を追加`"
            ok-title="追加"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="close"
            @hidden="close">
            <form @submit.stop.prevent="addMedicalCourse">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="name" class="is-required-ja">{{ $locale.consultation_host }}科名</label>
                            <input
                                v-model="medical_course.name"
                                id="name"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.name }"
                                type="text">
                            <div
                                v-if="errors.name"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.name[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="name_kana" class="is-required-ja">{{ $locale.consultation_host }}科名（カナ）</label>
                            <input
                                v-model="medical_course.name_kana"
                                id="name_kana"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.name_kana }"
                                type="text">
                            <div
                                v-if="errors.name_kana"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.name_kana[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label for="name">{{ $locale.consultation_host }}科の説明</label>
                            <input
                                v-model="medical_course.description"
                                id="description"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.description }"
                                type="text">
                            <div
                                v-if="errors.description"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.description[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">英語化問診票作成</label>
                            <div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.can_interview_trans"
                                        type="radio"
                                        id="can_interview_trans_true"
                                        class="form-check-input"
                                        :value="true">
                                    <label
                                        class="form-check-label"
                                        for="can_interview_trans_true">
                                        ON
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.can_interview_trans"
                                        type="radio"
                                        id="can_interview_trans_false"
                                        class="form-check-input"
                                        :value="false">
                                    <label
                                        class="form-check-label"
                                        for="can_interview_trans_false">
                                        OFF
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="errors.can_interview_trans"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.can_interview_trans[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">マッチング予約</label>
                            <div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.can_matching"
                                        type="radio"
                                        id="can_matching_true"
                                        class="form-check-input"
                                        :value="true">
                                    <label
                                        class="form-check-label"
                                        for="can_matching_true">
                                        ON
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.can_matching"
                                        type="radio"
                                        id="can_matching_false"
                                        class="form-check-input"
                                        :value="false">
                                    <label
                                        class="form-check-label"
                                        for="can_matching_false">
                                        OFF
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="errors.can_matching"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.can_matching[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label
                                for="matching_minutes"
                                :class="{ 'is-required-ja' : medical_course.can_matching }">
                                マッチング{{ $locale.consultation_host }}時間
                            </label>
                            <select
                                v-model="medical_course.matching_minutes"
                                :disabled="!medical_course.can_matching"
                                style="min-width: 100px;"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.matching_minutes }">
                                <option :value="null">選択してください</option>
                                <option
                                    v-for="minutes in matchingMinutes"
                                    :value="minutes">
                                    {{ minutes }}分
                                </option>
                            </select>
                            <div
                                v-if="errors.matching_minutes"
                                class="invalid-feedback d-block">
                                {{ errors.matching_minutes[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="mb-3">
                            <label
                                for="matching_price"
                                :class="{ 'is-required-ja' : medical_course.can_matching }">
                                マッチング{{ $locale.consultation_host }}料<span class="small">&nbsp;(税別)</span>
                            </label>
                            <input
                                v-model="medical_course.matching_price"
                                :disabled="!medical_course.can_matching"
                                type="text"
                                id="priority_num"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.matching_price }">
                            <div
                                v-if="errors.matching_price"
                                class="invalid-feedback d-block">
                                {{ errors.matching_price[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">マッチング予約のみ表示</label>
                            <div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.is_only_matching"
                                        :disabled="!medical_course.can_matching"
                                        type="radio"
                                        id="is_only_matching_true"
                                        class="form-check-input"
                                        :value="true">
                                    <label
                                        class="form-check-label"
                                        for="is_only_matching_true">
                                        ON
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.is_only_matching"
                                        :disabled="!medical_course.can_matching"
                                        type="radio"
                                        id="is_only_matching_false"
                                        class="form-check-input"
                                        :value="false">
                                    <label
                                        class="form-check-label"
                                        for="is_only_matching_false">
                                        OFF
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="errors.is_only_matching"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.is_only_matching[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="priority_num" class="is-required-ja">表示優先度</label>
                            <input
                                v-model="medical_course.priority_num"
                                type="text"
                                id="priority_num"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.priority_num }">
                            <span class="small text-muted">※数値が大きいほど先に表示されます</span>
                            <div
                                v-if="errors.priority_num"
                                class="invalid-feedback d-block">
                                {{ errors.priority_num[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">{{ $locale.consultation_host }}科の表示</label>
                            <div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.flg_show"
                                        type="radio"
                                        id="flg_show_true"
                                        class="form-check-input"
                                        :value="true">
                                    <label
                                        class="form-check-label"
                                        for="flg_show_true">
                                        表示
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="medical_course.flg_show"
                                        type="radio"
                                        id="flg_show_false"
                                        class="form-check-input"
                                        :value="false">
                                    <label
                                        class="form-check-label"
                                        for="flg_show_false">
                                        非表示
                                    </label>
                                </div>
                            </div>
                            <div
                                v-if="errors.flg_show"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.flg_show[0]}}
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div slot="modal-footer" class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button
                    class="btn btn-yokumiru-orange float-right"
                    :disabled="inProgress"
                    @click="handleOk">
                    追加
                </button>
                <button
                    class="btn btn-yokumiru-gray float-right mr-2"
                    :disabled="inProgress"
                    @click="close">
                    キャンセル
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                inProgress: false,
                modalShow: false,
                medical_course: {
                    name: null,
                    name_kana: null,
                    description: null,
                    can_interview_trans: false,
                    can_matching: false,
                    is_only_matching: false,
                    matching_minutes: null,
                    matching_price: null,
                    priority_num: 1,
                    flg_show: true,
                },
                matchingMinutes: [15, 30, 45, 60],
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-add-medical-course', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-add-medical-course')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.initMedicalCourse()
                this.modalShow = true
            },

            /**
             * 相談科データ初期化
             */
            initMedicalCourse: function () {
                this.medical_course = {
                    name: null,
                    name_kana: null,
                    description: null,
                    can_interview_trans: false,
                    can_matching: false,
                    is_only_matching: false,
                    matching_minutes: null,
                    matching_price: null,
                    priority_num: 1,
                    flg_show: true,
                }
            },

            /**
             * 追加ボタン押下時
             *
             * @param {object} e
             */
            handleOk: function (e) {
                e.preventDefault()
                this.addMedicalCourse()
            },

            /**
             * 相談科追加
             */
            addMedicalCourse: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await axios.post(constants.admin.medical_courses.endpoint.base, this.medical_course)
                    .then(() => {
                        bus.$emit('alert-success', `${this.$locale.consultation_host}科を追加しました。`)
                        bus.$emit('fetch-medical-courses')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            if (response.data.errors.hasOwnProperty('message')) {
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            }
                            else {
                                this.errors = response.data.errors
                                bus.$emit('alert-danger')
                            }
                        }
                    })

                this.inProgress = false
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.errors = {}
                this.modalShow = false
            },
        },
    }
</script>
